import Global from "@/scripts/Global"
import VueSignals from "@/scripts/VueSignals";

export default {
    name: 'DeleteChannel',
    data() {
        return {
            currData: {
                'channel_name': '',
                'channel_id': '',
                'type': ''
            },
            confirmCheck: false,
        }
    },
    mounted() {
        this.currData = this.$parent.data
    },
    methods: {
        deleteFF() {
            if (this.confirmCheck) {
                Global.globalValue(VueSignals.DELETE_CHANNEL_CONFIRMATION, {
                    'channel_id': this.currData.channel_id,
                    'type': this.currData.type
                })
            }
        }
    }
}
